import BaseEntity from "./BaseEntity";
import GameState from "../state/gameState";
import Phaser from "phaser";
import { BOARD_SIZE, layerDepthDiff } from "../constants";

import data from "../artConfig.json";

export default class Teleporter extends BaseEntity {
  private sprite: Phaser.GameObjects.Sprite;
  constructor(
    gameState: GameState,
    scene: Phaser.Scene,
    x: number,
    y: number,
    levelNumber: number
  ) {
    super(gameState, scene);

    this.sprite = this.scene.add.sprite(
      x * BOARD_SIZE,
      y * BOARD_SIZE,
      "atlas",
      "Teleporter/Teleporter1"
    );
    this.sprite.setDepth(y + layerDepthDiff.BUTTON);
    this.triggerShine();

    const shineFX = this.scene.add.sprite(
      x * BOARD_SIZE,
      y * BOARD_SIZE,
      "atlas",
      "FX/end_circle/end_circle_glow_1"
    );

    shineFX.setAlpha(0.5);

    shineFX.play(data.animations.end_circle_glow.key);
    shineFX.setDepth(y + layerDepthDiff.BUTTON);

    if (levelNumber !== -1 && levelNumber !== undefined) {
      const text = this.scene.add.bitmapText(
        0,
        0,
        "bitPixelFont",
        `${levelNumber}`
      );
      text.setOrigin(0, 0.5);
      text.setDepth(1200);
      text.setPosition(x * BOARD_SIZE, y * BOARD_SIZE);
      this.scene.add.tween({
        targets: text,
        y: { from: y * BOARD_SIZE, to: y * BOARD_SIZE - 3 },
        yoyo: true,
        repeatDelay: 50,
        repeat: -1,
        ease: "Power1",
        duration: 1000,
      });
    }
  }

  triggerShine() {
    if (!this.sprite.anims.isPlaying) {
      this.sprite.anims.play(data.animations.teleporter_shine.key);
    }
    this.scene.time.delayedCall(
      3000 + Math.random() * 3000,
      this.triggerShine,
      undefined,
      this
    );
  }
}
